// --- Domain Status ---
// --- Error Codes ---
export const ERROR_CODES = {
    VALIDATION_ERROR: 'VALIDATION_ERROR',
    INPUT_TOO_LARGE: 'INPUT_TOO_LARGE',
    RATE_LIMITED: 'RATE_LIMITED',
    INTERNAL_ERROR: 'INTERNAL_ERROR',
    UPSTREAM_ERROR: 'UPSTREAM_ERROR',
    TIMEOUT: 'TIMEOUT',
};
// --- Constants ---
export const MAX_DOMAINS_PER_REQUEST = 20;
export const DEFAULT_TLDS = ['com', 'net', 'org'];
export const CACHE_TTL_SECONDS = 900;
//# sourceMappingURL=types.js.map